<div class="site-page-header-ghost-wrapper">
    <nz-page-header class="site-page-header" nzBackIcon nzBack nzTitle="Banner" nzSubtitle=" - Cadastro/edição de banners.">
    </nz-page-header>

    <form nz-form [formGroup]="bannerForm" autocomplete="off" (ngSubmit)="onSubmitMensagem()" nzLayout="vertical">
        <div nz-row [nzGutter]="{ md: 24 }">
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label>Link:</nz-form-label>

                    <nz-form-control>
                        <input nz-input name="link" formControlName="link" placeholder="Exemplo: https://exemplo.com.br" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired>Exibições:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Selecione ao menos uma exibição.">
                        <nz-select formControlName="exibicao" nzMode="multiple" nzPlaceHolder="Selecione onde o banner será exibido">
                            <nz-option *ngFor="let exibicao of exibicoes" [nzLabel]="exibicao.label"
                                [nzValue]="exibicao.value"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired>Banner:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <div class="upload-card">
                            <input id="bannerFile" class="upload-input" nz-input type="file" accept="image/*"
                                (change)="onBannerFileChange($event)" />
                            <label class="upload-content" for="bannerFile">
                                <i nz-icon nzType="picture" nzTheme="outline"></i>
                                <div class="upload-text">
                                    <div class="upload-title">Clique para enviar</div>
                                    <div class="upload-subtitle">PNG ou JPG  <!--• Recomendado 1200×400--></div>
                                </div>
                                <span class="upload-action">Selecionar arquivo</span>
                            </label>
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
     
            <div nz-col nzSpan="24" *ngIf="bannerPreview">
                <nz-form-item>
                    <nz-form-label>Pré-visualização:</nz-form-label>
                    <nz-form-control>
                        <div class="preview-card">
                            <div class="preview-frame">
                                <img [src]="bannerPreview" alt="Prévia do banner" class="preview-image" />
                            </div>
                            <!--<div class="preview-hint">Ajuste a imagem para evitar cortes nas bordas.</div>-->
                        </div>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="10" nzOffset="7">
                <button nz-button nzType="primary" *ngIf="idmensagem" nzBlock>Atualizar</button>
                <button nz-button nzType="primary" *ngIf="!idmensagem" nzBlock>Cadastrar</button>
            </div>
        </div>
    </form>
</div>
